"use client";

import { useAuthorStore } from "@/stores/authorStore";
import { showToast } from "@/lib/toast";

interface ModalDeleteAuthorProps {
  isOpen: boolean;
  onClose: () => void;
  author: any;
  onComplete: () => void;
}

export default function ModalDeleteAuthor({ isOpen, onClose, author, onComplete }: ModalDeleteAuthorProps) {
  const { deleteAuthor, isDeleting } = useAuthorStore();

  const handleDelete = async () => {
    if (!author?._id) return;
    const ok = await deleteAuthor(author._id);
    if (ok) {
      showToast.success("Đã xóa", "Xóa tác giả thành công");
      onComplete();
      onClose();
    } else {
      showToast.error("Lỗi", "Không thể xóa tác giả");
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/30">
      <div className="bg-white rounded-lg shadow-lg w-full max-w-md mx-4">
        <div className="px-6 py-4 border-b border-gray-200">
          <h2 className="text-lg font-bold text-gray-900">Xóa tác giả</h2>
        </div>
        <div className="px-6 py-4">
          <p>Bạn có chắc muốn xóa tác giả "<span className="font-semibold">{author?.name}</span>"?</p>
        </div>
        <div className="px-6 py-4 border-t border-gray-200 flex justify-end gap-2">
          <button onClick={onClose} className="px-4 py-2 bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200">Hủy</button>
          <button onClick={handleDelete} disabled={isDeleting} className="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 disabled:opacity-50">
            {isDeleting ? "Đang xóa..." : "Xóa"}
          </button>
        </div>
      </div>
    </div>
  );
}


